import { render, staticRenderFns } from "./IndexationTableWidget.vue?vue&type=template&id=4af11807&"
import script from "./IndexationTableWidget.vue?vue&type=script&lang=js&"
export * from "./IndexationTableWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports